import './AccountPage.scss';

import * as React from 'react';
import { useEffect } from 'react';
import ReactDOM from 'react-dom';

import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { FeatureUseEventAdapter } from '~analytics/adapters/FeatureUseEventAdapter';
import { Divider } from '~shared/components/Divider';
import { TeamMembers } from '~teacher/components/Account/TeamMembers';
import { ConfirmLeaveTeamDialog } from '~teacher/components/Account/TeamMembers/ConfirmLeaveTeamDialog';
import { TeamSelector } from '~teacher/components/Account/TeamSelector';
import { TeamSettings } from '~teacher/components/Account/TeamSettings/TeamSettings';
import { TeamSubscription } from '~teacher/components/Account/TeamSubcription';
import { queryClient } from '~teacher/queryClient';

import { ErrorView } from '../../../shared/error/ErrorView';

export function AccountPage() {
  useEffect(() => {
    new FeatureUseEventAdapter({
      feature: 'account_page_teams',
      action: 'open',
    }).sendAnalytics();
  }, []);

  return (
    <>
      <div className="account-page-grid">
        <TeamSelector />
        <div className="col-span-2">
          <Divider />
        </div>
        <TeamSubscription />
        <div className="col-span-2">
          <Divider />
        </div>

        <>
          <TeamSettings />
          <div className="col-span-2">
            <Divider />
          </div>
        </>
        <TeamMembers />
      </div>
      <ConfirmLeaveTeamDialog />
    </>
  );
}

export default function doAccountPage() {
  ReactDOM.render(
    <ErrorView>
      <QueryClientProvider client={queryClient}>
        <AccountPage />
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </ErrorView>,
    document.getElementById('main-content')
  );
}
